import { ReactComponent as FlagIcon } from "./svg/gb-flag.svg";
import "../flag-icon.scss";

export const GBFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
